<div class="modal-header">
  <div class="modal-header-title">Bounded Summary Forms</div>
</div>
<div class="modal-body">
  <div class="alert alert-info">
    <p class="text-center">{{ explanation }}</p>
  </div>

  <table class="table table-striped user-list">
    <tbody>
      <tr>
        <th>Form</th>
        <th>Date</th>
        <th>Evaluation Range</th>
        <th>Status</th>
      </tr>
      @for (item of summaryFormInstances; track item) {
      <tr [class.clickable]="isClickable" (click)="openFormInstance(item.Id)">
        <td>
          {{ item.Name | instanceNumber: item.InstanceNumber }}
        </td>
        <td>
          {{ item.WorkDate | agencyDate }}
        </td>
        <td>{{ item.MinDate | agencyDate }} - {{ item.MaxDate | agencyDate }}</td>
        <td>
          {{ item.Status }}
        </td>
      </tr>
      }
    </tbody>
  </table>
  <div class="alert alert-info">
    <p class="text-center">
      By {{ actionProcess }} this form we will automatically reject the form(s) above since the information may change.
      Are you sure you wish to {{ actionText }} this form?
    </p>
  </div>
</div>
<div class="modal-footer">
  <div class="buttons-box">
    <button (click)="cancel()" type="button" class="fto-legacy-btn btn btn-default">No, Cancel</button>
    <button type="button" class="fto-legacy-btn btn btn-primary" (click)="onConfirm()">{{ actionButtonText }}</button>
  </div>
</div>
